import React from 'react';
import { ResourceSite } from '../../../hooks/resourceSiteHooks';
import { getLocationDisplay } from '../../utils/ResourceRequestUtils';

interface LocationDisplayProps {
  metadata: any;
  resourceSites?: ResourceSite[];
}

const LocationDisplay: React.FC<LocationDisplayProps> = ({
  metadata,
  resourceSites,
}) => {
  const requestedReportingLocationId =
    metadata.items?.[0]?.requested_reporting_location_id;
  const requestedReportingLocationGeolocation =
    metadata.items?.[0]?.requested_reporting_location_geolocation;

  if (
    !metadata.source_location_id &&
    !metadata.source_location_geolocation &&
    !requestedReportingLocationId &&
    !requestedReportingLocationGeolocation
  ) {
    return null;
  }

  const toLocationContent =
    requestedReportingLocationId || requestedReportingLocationGeolocation
      ? getLocationDisplay(
          requestedReportingLocationId,
          requestedReportingLocationGeolocation,
          resourceSites
        )
      : 'Not specified';

  return (
    <div className="mt-2 small">
      <strong>Locations:</strong>
      <div className="ms-2">
        From:{' '}
        {getLocationDisplay(
          metadata.source_location_id,
          metadata.source_location_geolocation,
          resourceSites
        )}
      </div>
      <div className="ms-2">To: {toLocationContent}</div>
    </div>
  );
};

export default LocationDisplay;
